import { type ReactNode } from 'react';

import { useHandleUnauthenticatedHomeLayoutUser } from '~/components/Layouts/HomeLayout/hooks/useHandleUnauthenticatedHomeLayoutUser.ts';
import { RedirectToExternalContainer } from '~/components/RedirectToExternalContainer';
import { useAccountProvisionerContext } from '../providers/AccountProvisionerProvider';
import { AccountProvisioningFailedState } from './AccountProvisioningFailedState';
import { SSOInProgress } from './SSOInProgress';

type AccountProvisionLayoutProps = {
  children: ReactNode;
};

/**
 * @TODO - This should not be a layout, update this to be a proper wrapper
 * component and separate the components in this file.
 */
export const AccountProvisionLayout = ({ children }: AccountProvisionLayoutProps) => {
  const { inProgress, hasError, continuedWithAccountProvisioningError } = useAccountProvisionerContext();
  useHandleUnauthenticatedHomeLayoutUser();

  // If the account provisioner is in progress, show the in progress state
  if (inProgress) {
    return (
      <RedirectToExternalContainer>
        <SSOInProgress />
      </RedirectToExternalContainer>
    );
  }
  // If there is an error, show the error state
  if (hasError) {
    return continuedWithAccountProvisioningError ? (
      // biome-ignore lint/complexity/noUselessFragments: HomeLayout throws an error if children is not a fragment
      <>{children}</>
    ) : (
      <RedirectToExternalContainer>
        <AccountProvisioningFailedState />
      </RedirectToExternalContainer>
    );
  }

  // If we are here, it means that accountProvisioner is fetched and there is no error
  return <>{children}</>;
};
